const mjmlTemplate = `<mjml>
  <mj-head>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif" color="#3b4c56" />
      <mj-text font-size="15px" line-height="1.6" padding="0" />
      <mj-section padding="0" />
      <mj-column padding="0" />
    </mj-attributes>
    <mj-preview>{{preheaderText}}</mj-preview>
    <mj-style inline="inline">
      .markdown p + p { margin-top: 10px; }
      .markdown ul, .markdown ol { margin: 10px 0; padding-left: 20px; }
      .markdown li + li { margin-top: 6px; }
      .markdown a:not(.editorial-pill-cta-link) { color: inherit; text-decoration: underline; }
      .markdown strong { font-weight: 600; }
      .markdown em { font-style: italic; }
      .legal a { color: inherit !important; text-decoration: underline; }
      .legal-links a { cursor: pointer; }
      .social-icon {
        width: 30px !important; height: 30px !important; border-radius: 30px !important;
        background-color: rgba(255,255,255,0.7); display: inline-block;
      }
      .footer-name-address { opacity: .8; font-size: 12px; }
      .footer-name-address p { font-size: 12px !important; margin: 0 0 4px 0; }
      .section-kicker div {
        font-size: 10px !important;
        letter-spacing: 0.14em !important;
        text-transform: uppercase !important;
        color: #888888 !important;
        font-weight: 600 !important;
      }
      .gallery-caption div {
        font-size: 12px !important;
        line-height: 1.4 !important;
        color: #3b4c56 !important;
        text-align: center !important;
      }
      .personal-block div { text-align: left !important; color: #3b4c56 !important; }
      .quote-text div {
        font-size: 16px !important;
        line-height: 1.5 !important;
        font-style: italic !important;
        color: #111827 !important;
      }
      .quote-author div {
        font-size: 12px !important;
        color: #888888 !important;
      }
      .experience-title div {
        font-size: 15px !important;
        font-weight: 600 !important;
        color: #000000 !important;
        text-align: center !important;
      }
      .experience-desc div {
        font-size: 13px !important;
        line-height: 1.5 !important;
        color: #3b4c56 !important;
        text-align: center !important;
      }
      .experience-image img {
        display: block !important;
        width: 100% !important;
        max-width: 160px !important;
        height: auto !important;
        margin: 0 auto !important;
      }
      .lifestyle-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        border-radius: 4px;
      }
      .display-title-serif div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 28px !important;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        color: #182852 !important;
        text-align: center !important;
      }
      .feature-block .markdown h2,
      .feature-block .markdown h3 {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 22px !important;
        line-height: 1.3 !important;
        font-weight: 400 !important;
        color: #111827 !important;
        margin: 0 0 10px 0 !important;
      }
      .text-link-arrow a {
        color: #182852 !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        text-decoration: underline !important;
        text-underline-offset: 3px !important;
      }
      .text-link-arrow-empty {
        display: none !important;
        max-height: 0 !important;
        overflow: hidden !important;
        font-size: 0 !important;
        line-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      .discover-tile-label div {
        font-size: 13px !important;
        line-height: 1.4 !important;
        color: #3b4c56 !important;
        text-align: center !important;
        padding-top: 8px !important;
      }
      .discover-tile-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        border-radius: 2px;
      }
      .amenity-title div {
        font-size: 11px !important;
        letter-spacing: 0.12em !important;
        text-transform: uppercase !important;
        font-weight: 600 !important;
        color: #111827 !important;
        text-align: center !important;
        padding-top: 10px !important;
      }
      .amenity-image img {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        border-radius: 2px;
      }
      .discover-link a {
        display: inline-block !important;
        width: 100% !important;
        box-sizing: border-box !important;
        text-align: center !important;
        padding: 10px 16px !important;
        border: 1px solid #d7d8df !important;
        color: #3b4c56 !important;
        text-decoration: none !important;
        font-size: 14px !important;
        margin-bottom: 8px !important;
      }
      .header-tagline-script div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 26px !important;
        font-style: italic !important;
        color: #182852 !important;
        text-align: center !important;
        line-height: 1.2 !important;
      }
      .header-tagline-sans div {
        font-size: 10px !important;
        letter-spacing: 0.22em !important;
        text-transform: uppercase !important;
        color: #3b4c56 !important;
        text-align: center !important;
        padding-top: 6px !important;
      }
      .arch-image img {
        border-radius: 280px 280px 0 0 !important;
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .editorial-hero-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        border-radius: 0 !important;
      }
      .editorial-experiences-title div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 30px !important;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        color: #182852 !important;
        text-align: center !important;
      }
      .editorial-story-copy div,
      .editorial-story-copy p {
        color: #3b4c56 !important;
        text-align: center !important;
      }
      .editorial-pill-cta {
        text-align: center !important;
      }
      .editorial-pill-cta div {
        text-align: center !important;
      }
      .editorial-pill-cta-cell {
        border: 1px solid {{ctaBackgroundColor}} !important;
        border-radius: 999px !important;
        background-color: #ffffff !important;
        padding: 12px 36px !important;
        text-align: center !important;
      }
      .editorial-pill-cta-link {
        color: {{ctaTextColor}} !important;
        text-decoration: none !important;
        font-family: Inter, Arial, sans-serif !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        letter-spacing: 0.08em !important;
        display: inline-block !important;
        line-height: 1.2 !important;
        white-space: nowrap !important;
      }
      .markdown a.editorial-pill-cta-link,
      .editorial-pill-cta .editorial-pill-cta-link,
      .mjml-cta-story .editorial-pill-cta-link,
      .mjml-cta-story .editorial-pill-cta-link-inner,
      td.mjml-cta-story a.editorial-pill-cta-link {
        color: {{ctaTextColor}} !important;
        text-decoration: none !important;
      }
      .editorial-pill-cta-link-inner {
        border: none !important;
        padding: 0 !important;
        background-color: transparent !important;
        border-radius: 0 !important;
        color: {{ctaTextColor}} !important;
      }
      .editorial-pill-cta-bulletproof {
        border-collapse: separate !important;
        border-spacing: 0 !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }
      .editorial-story-image td {
        text-align: center !important;
      }
      .editorial-story-image img {
        max-width: 440px !important;
        width: 100% !important;
        height: auto !important;
        display: block !important;
        margin: 0 auto !important;
        border-radius: 220px 220px 0 0 !important;
        padding-bottom: 4px !important;
      }
      .editorial-footer-social td {
        text-align: right !important;
        vertical-align: middle !important;
      }
      .editorial-footer-social a {
        text-decoration: none !important;
        display: inline-block !important;
      }
      .editorial-footer-legal div,
      .editorial-footer-legal p {
        color: #ffffff !important;
        font-size: 12px !important;
        line-height: 1.65 !important;
        text-align: center !important;
        margin: 0 0 10px 0 !important;
      }
      .editorial-footer-legal a {
        color: #ffffff !important;
        text-decoration: underline !important;
      }
      .editorial-footer-divider p {
        border-color: rgba(255, 255, 255, 0.55) !important;
      }
      .hero-overlay-text div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 28px !important;
        font-style: italic !important;
        color: #182852 !important;
        text-align: center !important;
        padding: 12px 0 0 0 !important;
      }
      .navy-footer-text div, .navy-footer-text p {
        color: #ffffff !important;
        font-size: 12px !important;
        line-height: 1.5 !important;
      }
      .navy-footer-text a {
        color: #ffffff !important;
        text-decoration: underline !important;
      }
      .editorial-footer-top .navy-footer-text div,
      .editorial-footer-top .navy-footer-text p {
        word-break: normal !important;
        overflow-wrap: anywhere !important;
      }
      @media only screen and (max-width: 480px) {
        .editorial-footer-top .mj-column-per-50,
        .editorial-footer-top .mj-column-per-52,
        .editorial-footer-top .mj-column-per-58,
        .editorial-footer-top .mj-column-per-48,
        .editorial-footer-top .mj-column-per-42 {
          width: 100% !important;
          max-width: 100% !important;
        }
        .editorial-footer-social td {
          text-align: center !important;
          padding-top: 18px !important;
        }
        .editorial-footer-top .navy-footer-text {
          text-align: center !important;
        }
      }
      .fine-print div {
        font-size: 11px !important;
        line-height: 1.5 !important;
        color: #6b7280 !important;
        font-style: italic !important;
      }
      .resort-footer-logo img {
        width: 72px !important;
        height: auto !important;
        margin: 0 auto !important;
        display: block !important;
      }
      .gallery-row-four img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .resort-invite-title div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 32px !important;
        line-height: 1.2 !important;
        font-weight: 400 !important;
        color: #2b2b2b !important;
        text-align: center !important;
      }
      .resort-invite-body div,
      .resort-invite-body p {
        color: #3b3b3b !important;
        text-align: center !important;
      }
      .resort-invite-body a {
        color: #1e5a8a !important;
        text-decoration: underline !important;
      }
      .resort-discover-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .resort-discover-title div {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 30px !important;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        color: #2b2b2b !important;
        text-align: center !important;
      }
      .resort-discover-intro div {
        font-size: 15px !important;
        line-height: 1.65 !important;
        color: #4a4a4a !important;
        text-align: center !important;
      }
      .resort-ghost-button-wrap {
        vertical-align: top !important;
      }
      .resort-ghost-button-cell {
        border: 1px solid #9ca3af !important;
      }
      .resort-ghost-button-cell a {
        color: #4a5563 !important;
        text-decoration: none !important;
        font-family: Inter, Arial, sans-serif !important;
        font-size: 11px !important;
        font-weight: 600 !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        display: block !important;
        line-height: 1.2 !important;
      }
      .resort-footer-contact div,
      .resort-footer-contact a {
        font-size: 14px !important;
        line-height: 1.5 !important;
        text-align: center !important;
      }
      .resort-footer-address div {
        font-size: 12px !important;
        line-height: 1.5 !important;
        color: #6b7280 !important;
        text-align: center !important;
      }
      .resort-header-logo img {
        width: auto !important;
        max-width: 160px !important;
        height: auto !important;
        max-height: 120px !important;
        margin: 0 auto !important;
        display: block !important;
      }
      .resort-footer-emblem img {
        width: auto !important;
        max-width: 140px !important;
        height: auto !important;
        max-height: 120px !important;
        margin: 0 auto !important;
        display: block !important;
      }
      .resort-footer-legal a {
        color: #2b2b2b !important;
        text-decoration: underline !important;
        font-size: 12px !important;
      }
      @media only screen and (max-width: 480px) {
        .experience-col, .gallery-col, .split-col, .social-quote-col, .social-photo-col {
          width: 100% !important;
          max-width: 100% !important;
        }
        .zigzag-image-col, .zigzag-text-col {
          width: 100% !important;
          max-width: 100% !important;
          display: block !important;
        }
      }

    </mj-style>
  </mj-head>
  <mj-body background-color="#EEF1F7" width="600px">
    <mj-wrapper border="1px solid #D7D8DF" padding="0">

      <mj-section background-color="#FFFFFF" padding="36px 30px 28px" css-class="mjml-header">
        <mj-column>
          <mj-image src="{{logoUrl}}" alt="Logo" align="center" padding="0" width="{{logoWidth}}" height="{{logoHeight}}" css-class="mjml-logo resort-header-logo" />
        </mj-column>
      </mj-section>
      <mj-section padding="0" css-class="mjml-hero">
        <mj-column>
          <mj-image src="{{heroImgUrl}}" alt="Hero" padding="0" href="{{heroImageLinkUrl}}" fluid-on-mobile="true" />
        </mj-column>
      </mj-section>
      <mj-section padding="28px 48px 8px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          <mj-text css-class="resort-invite-title" padding="0 0 20px 0" align="center">{{emailTitle}}</mj-text>
          <mj-text css-class="markdown resort-invite-body" padding="0" line-height="1.65" font-size="15px" align="center">
            <!-- bodyHtml -->
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section padding="8px 48px 32px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          
          <mj-table css-class="mjml-cta resort-solid-cta" padding="0" width="100%">
            <tr>
              <td class="resort-solid-cta-cell" align="center" style="background-color:{{ctaBackgroundColor}};border-radius:2px;padding:16px 24px;text-align:center;">
                <a href="{{ctaUrl}}" class="resort-solid-cta-link" style="color:{{ctaTextColor}};text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:13px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;display:inline-block;line-height:1.2;">{{ctaText}}</a>
              </td>
            </tr>
          </mj-table>
        </mj-column>
      </mj-section>
      <mj-section padding="0 48px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          <mj-divider border-width="1px" border-color="#e5e7eb" padding="0" />
        </mj-column>
      </mj-section>
      <mj-section padding="28px 0 0" css-class="mjml-lifestyle" background-color="#FFFFFF">
        <mj-column>
          <mj-image src="{{lifestyleImage}}" alt="{{lifestyleImageAlt}}" padding="0" fluid-on-mobile="true" css-class="resort-discover-image" href="{{lifestyleImageLinkUrl}}" />
        </mj-column>
      </mj-section>
      <mj-section padding="28px 48px 8px" css-class="mjml-discoverIntro" background-color="#FFFFFF">
        <mj-column>
          <mj-text css-class="resort-discover-title" align="center" padding="0 0 14px 0">{{galleryTitle}}</mj-text>
          <mj-text css-class="resort-discover-intro" align="center" padding="0 0 16px 0">{{discoverIntroText}}</mj-text>
        </mj-column>
      </mj-section>
      
      <mj-section padding="0 34px 28px" css-class="mjml-discoverButtons resort-discover-buttons-section" background-color="#FFFFFF">
        <mj-column padding="0">
          <mj-table css-class="resort-ghost-buttons" padding="0" width="100%">
            <tr>
              
              <td data-discover-button="1" class="resort-ghost-button-wrap" style="width:50%;padding:0 6px 10px 6px;vertical-align:top;">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                  <tr>
                    <td class="resort-ghost-button-cell" style="border:1px solid #9ca3af;padding:14px 10px;text-align:center;">
                      <a href="{{discoverBtn1LinkUrl}}" style="color:#4a5563;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;display:block;line-height:1.2;">{{discoverBtn1}}</a>
                    </td>
                  </tr>
                </table>
              </td>
              
              <td data-discover-button="2" class="resort-ghost-button-wrap" style="width:50%;padding:0 6px 10px 6px;vertical-align:top;">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                  <tr>
                    <td class="resort-ghost-button-cell" style="border:1px solid #9ca3af;padding:14px 10px;text-align:center;">
                      <a href="{{discoverBtn2LinkUrl}}" style="color:#4a5563;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;display:block;line-height:1.2;">{{discoverBtn2}}</a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              
              <td data-discover-button="3" class="resort-ghost-button-wrap" style="width:50%;padding:0 6px 10px 6px;vertical-align:top;">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                  <tr>
                    <td class="resort-ghost-button-cell" style="border:1px solid #9ca3af;padding:14px 10px;text-align:center;">
                      <a href="{{discoverBtn3LinkUrl}}" style="color:#4a5563;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;display:block;line-height:1.2;">{{discoverBtn3}}</a>
                    </td>
                  </tr>
                </table>
              </td>
              
              <td data-discover-button="4" class="resort-ghost-button-wrap" style="width:50%;padding:0 6px 10px 6px;vertical-align:top;">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                  <tr>
                    <td class="resort-ghost-button-cell" style="border:1px solid #9ca3af;padding:14px 10px;text-align:center;">
                      <a href="{{discoverBtn4LinkUrl}}" style="color:#4a5563;text-decoration:none;font-family:Inter,Arial,sans-serif;font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;display:block;line-height:1.2;">{{discoverBtn4}}</a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </mj-table>
        </mj-column>
      </mj-section>
      <mj-section padding="0 48px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          <mj-divider border-width="1px" border-color="#e5e7eb" padding="0" />
        </mj-column>
      </mj-section>
      <mj-section padding="0 0 8px" css-class="mjml-gallery" background-color="#FFFFFF">
        <mj-column width="25%" padding="1px" css-class="gallery-col">
          <mj-image css-class="gallery-row-four" src="{{gallery1Image}}" alt="Gallery 1" padding="0" href="{{gallery1ImageLinkUrl}}" />
        </mj-column>
        <mj-column width="25%" padding="1px" css-class="gallery-col">
          <mj-image css-class="gallery-row-four" src="{{gallery2Image}}" alt="Gallery 2" padding="0" href="{{gallery2ImageLinkUrl}}" />
        </mj-column>
        <mj-column width="25%" padding="1px" css-class="gallery-col">
          <mj-image css-class="gallery-row-four" src="{{gallery3Image}}" alt="Gallery 3" padding="0" href="{{gallery3ImageLinkUrl}}" />
        </mj-column>
        <mj-column width="25%" padding="1px" css-class="gallery-col">
          <mj-image css-class="gallery-row-four" src="{{gallery4Image}}" alt="Gallery 4" padding="0" href="{{gallery4ImageLinkUrl}}" />
        </mj-column>
      </mj-section>
      <mj-section padding="24px 40px 8px" css-class="mjml-footer" background-color="#FFFFFF">
        <mj-column>
          <mj-text css-class="resort-footer-contact" align="center" padding="0 0 8px 0">
            <a href="tel:{{hotelPhone}}" style="color:#1e5a8a;text-decoration:underline;">{{hotelPhone}}</a>
            <span style="color:#3b3b3b;"> | </span>
            <a href="{{hotelWebsiteUrl}}" style="color:#1e5a8a;text-decoration:underline;">{{hotelWebsite}}</a>
          </mj-text>
          <mj-text css-class="resort-footer-address" align="center" padding="0 0 20px 0">
            {{hotelAddress}}<br/>{{hotelCityStateZip}}
          </mj-text>
          <mj-table align="center" padding="0 0 24px 0">
            <tr>
              <td style="text-align: center;">
                <!-- socialMediaLinksHtml -->
              </td>
            </tr>
          </mj-table>
          <mj-divider border-width="1px" border-color="#e5e7eb" padding="0 0 24px 0" />
          <mj-image src="{{logoUrl}}" alt="Logo" align="center" padding="0 0 20px 0" width="{{footerLogoWidth}}" css-class="resort-footer-emblem" />
          <mj-text align="center" css-class="resort-footer-legal" padding="0 0 28px 0">
            <a href="{{unsubscribeUrl}}">Unsubscribe</a>
            <span style="display:inline-block;width:12px;"> </span>
            <a href="{{privacyPolicyUrl}}">Privacy Policy</a>
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`

export default mjmlTemplate
